export default "__VITE_ASSET__1335ea4e__"